/**
 * Shared string normalization and equality for OCR text vs configured identifier values.
 * Keep in sync with historical DocumentTypeDetectionService behavior.
 */
export function normalizeOcrIdentifierForCompare(s: string): string {
  return (s ?? '')
    .trim()
    .replace(/\s+/g, ' ')
    // OCR often swaps trailing/label punctuation (e.g. "TRANS NO," vs "TRANS NO.")
    .replace(/,/g, '.')
    .toLowerCase();
}

/**
 * True if OCR output matches the expected identifier string (after normalization).
 * Empty expected counts as match (nothing to verify).
 */
export function ocrIdentifierValuesMatch(ocrText: string, expected: string): boolean {
  const ocr = normalizeOcrIdentifierForCompare(ocrText);
  const identifier = normalizeOcrIdentifierForCompare(expected);
  if (!identifier.length) return true;
  if (!ocr.length) return false;
  return ocr === identifier || ocr.includes(identifier);
}
